/* fail-safe */try{
/* Proactive Coaching — Book-a-speaker modal.
 *
 * Intercepts every link to /book-now/ site-wide (CTA buttons, the talk
 * cards' "Request this presentation" links, footer links) and opens the
 * booking form modal instead (markup: partials/book-modal.hbs). A
 * ?talk=<title> query on the link pre-selects that presentation.
 *
 * Submit POSTs to the pc-ask-bruce Worker, which mails Rob via Resend. On any
 * failure (API key, network down, rate limit) it falls back to a prefilled
 * mailto: in the visitor's own mail app, because a booking enquiry must never
 * be lost to a failed fetch. TO below is rob@proactivecoaching.ai — a Workspace
 * group forwarding to his inbox — and matches both the address the modal shows
 * the visitor and the Worker's own BOOK_TO.
 * Without JS, links fall through to the /book-now/ fallback page.
 */
(function () {
    var modal = document.getElementById('pc-book');
    var scrim = document.getElementById('pc-book-scrim');
    var form = document.getElementById('pc-book-form');
    if (!modal || !scrim || !form) return;

    var TO = 'rob@proactivecoaching.ai';
    var lastFocus = null;

    function open(talk) {
        if (talk) {
            var sel = document.getElementById('pc-book-talk');
            for (var i = 0; i < sel.options.length; i++) {
                if (sel.options[i].text.trim() === talk.trim()) { sel.selectedIndex = i; break; }
            }
        }
        /* Reopening after a successful send must show the form again, not the
           confirmation left over from last time. */
        var doneEl = document.getElementById('pc-book-done');
        if (doneEl) { doneEl.hidden = true; form.hidden = false; }
        lastFocus = document.activeElement;
        modal.hidden = false; scrim.hidden = false;
        document.documentElement.classList.add('pc-book-open');
        var first = form.querySelector('input');
        if (first && window.matchMedia('(min-width: 768px)').matches) first.focus();
    }
    function close() {
        modal.hidden = true; scrim.hidden = true;
        document.documentElement.classList.remove('pc-book-open');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href*="/book-now/"]');
        if (!a) return;
        e.preventDefault();
        var talk = null;
        try { talk = new URL(a.href, location.origin).searchParams.get('talk'); } catch (err) {}
        open(talk);
    });
    /* Landing on /book-now/ itself (the no-JS fallback page — from an email
       link, an old bookmark, or a click that raced the script) opens the form
       on top of it, honoring ?talk= just like an intercepted link would. The
       page's email/phone instructions stay usable underneath and for no-JS. */
    if (location.pathname.replace(/\/+$/, '') === '/book-now') {
        var qtalk = null;
        try { qtalk = new URL(location.href).searchParams.get('talk'); } catch (err) {}
        open(qtalk);
    }

    document.getElementById('pc-book-close').addEventListener('click', close);
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
    });

    /* POST to the Worker, which mails Rob a structured request and lets us
       show a real confirmation. On ANY failure - endpoint not deployed, no
       API key, network down, rate limit - we fall back to the mailto: path
       that shipped before this. A booking enquiry is the most valuable thing
       on the site; it must never be dropped because a fetch failed. */
    var ENDPOINT = 'https://ask.proactivecoaching.ai/book';
    var done = document.getElementById('pc-book-done');
    var sendBtn = form.querySelector('.pc-book-send');

    function fields() {
        var v = function (n) { return (form.elements[n] && form.elements[n].value || '').trim(); };
        var talkSel = form.elements.talk;
        return {
            name: v('name'), email: v('email'), org: v('org'), audience: v('audience'),
            talk: talkSel.value || talkSel.options[talkSel.selectedIndex].text,
            dates: v('dates'), notes: v('notes'), website: v('website')
        };
    }

    function mailtoFallback(f) {
        var body = [
            'Name: ' + f.name,
            'Email: ' + f.email,
            'School / organization & location: ' + f.org,
            'Audience: ' + f.audience,
            'Presentation: ' + (f.talk || 'Not sure yet - recommend one'),
            'Preferred dates: ' + (f.dates || '-'),
            '',
            f.notes
        ].join('\n');
        location.href = 'mailto:' + TO +
            '?subject=' + encodeURIComponent('Proactive Coaching speaker request - ' + (f.org || f.name)) +
            '&body=' + encodeURIComponent(body);
        var note = form.querySelector('.pc-book-note');
        if (note) note.innerHTML = 'Your email app should have opened with everything filled in - just hit send. ' +
            'If it didn\u2019t, email <b>' + TO + '</b> or call <a href="tel:+19134493356">(913) 449-3356</a>.';
    }

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.reportValidity && !form.reportValidity()) return;
        var f = fields();

        sendBtn.disabled = true;
        sendBtn.textContent = 'Sending\u2026';
        var restore = function () { sendBtn.disabled = false; sendBtn.innerHTML = 'Send to Rob &rarr;'; };

        fetch(ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(f)
        }).then(function (r) {
            if (!r.ok) throw new Error('http ' + r.status);
            form.hidden = true;
            done.hidden = false;
            if (window.gtag) gtag('event', 'speaker_request', { presentation: f.talk });
        }).catch(function () {
            restore();
            mailtoFallback(f);
        });
    });

    var doneClose = done && done.querySelector('.pc-book-done-close');
    if (doneClose) doneClose.addEventListener('click', close);
})();
}catch(e){/* never halt the bundle */}
